import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MssFieldBaseFieldTypeComponent } from '@shared/components/formly/fields/mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';

@Component({
  templateUrl: 'input.component.html',
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class InputFieldTypeComponent extends MssFieldBaseFieldTypeComponent {}
